// ============================================
// API Constants
// ============================================

export const API_VERSION = "v1";
export const API_PREFIX = `/api/${API_VERSION}`;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_ERROR: 500,
} as const;

// ============================================
// Error Codes
// ============================================

export const ERROR_CODES = {
  VALIDATION_ERROR: "VALIDATION_ERROR",
  NOT_FOUND: "NOT_FOUND",
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",
  RATE_LIMITED: "RATE_LIMITED",
  INTERNAL_ERROR: "INTERNAL_ERROR",
  CONFLICT: "CONFLICT",
} as const;

// ============================================
// Page Constants
// ============================================

export const PAGE_STATUSES = ["draft", "published", "archived"] as const;

export const DEFAULT_PAGE_LIMIT = 20;
export const MAX_PAGE_LIMIT = 100;

// ============================================
// Form Constants
// ============================================

export const FORM_TYPES = ["contact", "newsletter", "demo", "feedback"] as const;

export const FORM_STATUSES = ["new", "read", "archived"] as const;

export const MAX_FORM_SUBMISSIONS_PER_MINUTE = 5;

// ============================================
// Analytics Constants
// ============================================

export const ANALYTICS_EVENT_TYPES = [
  "page_view",
  "form_submit",
  "cta_click",
  "scroll_depth",
  "time_on_page",
] as const;

// ============================================
// Security Constants
// ============================================

export const RATE_LIMITS = {
  GENERAL: { windowMs: 60_000, max: 100 },
  FORM_SUBMIT: { windowMs: 60_000, max: 5 },
  AUTH: { windowMs: 60_000, max: 5 },
  ANALYTICS: { windowMs: 60_000, max: 100 },
} as const;

export const JWT_DEFAULTS = {
  ACCESS_TOKEN_EXPIRY: "15m",
  REFRESH_TOKEN_EXPIRY: "7d",
} as const;

// ============================================
// Application Constants
// ============================================

export const APP_NAME = "Landing Platform";
export const APP_URL = "https://yourdomain.com";
export const SUPPORT_EMAIL = "support@yourdomain.com";

// ============================================
// Cache Constants
// ============================================

export const CACHE_TTL = {
  SHORT: 60, // 1 minute
  MEDIUM: 300, // 5 minutes
  LONG: 3600, // 1 hour
  VERY_LONG: 86400, // 24 hours
} as const;
